module.exports = __webpack_public_path__ + "img/10022.4bbdcad2.png";